import { render, staticRenderFns } from "./OrderStatus.vue?vue&type=template&id=b78a4ad0&scoped=true"
import script from "./OrderStatus.vue?vue&type=script&lang=js"
export * from "./OrderStatus.vue?vue&type=script&lang=js"
import style0 from "./OrderStatus.vue?vue&type=style&index=0&id=b78a4ad0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b78a4ad0",
  null
  
)

export default component.exports